<template>
  <div id="schedule-report-book-list">
    <el-table
      :data="scheduleReports"
      class="table-responsive table-striped"
      header-row-class-name="thead-light"
      style="width: 100%;"
      row-key="id"
      :expand-row-keys="expandedRows"
    >
      <el-table-column label="Vendedor"         min-width="300px" prop="schedule.salesman_name" />
      <el-table-column label="Descrição"        min-width="300px" prop="schedule.note" />
      <el-table-column label="Início da Visita" min-width="220px" prop="schedule.date_start" >
        <template slot-scope="scope">
          {{ scope.row.schedule.date_start | formatDate('datetime') }}
        </template>
      </el-table-column>
      <el-table-column label="Fim da Visita" min-width="220px" prop="schedule.date_end">
        <template slot-scope="scope">
          {{ scope.row.schedule.date_end | formatDate('datetime') }}
        </template>
      </el-table-column>

      <el-table-column
        label="Ações"
        width="80px"
        prop="acoes"
        v-slot="{ row }"
      >
        <a @click="rowClicked(row)">
          <span class="btn btn-sm btn-icon-only text-success">
            <i class="fa fa-eye mt-2"></i>
          </span>
        </a>
      </el-table-column>

      <el-table-column type="expand">
        <template slot-scope="props">
          <div v-loading="loadingScheduleReportItems" class="schedule-report-book-list-items px-4 py-3 row">
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-4"
              v-for="scheduleReportItem in scheduleReportItems"
              :key="scheduleReportItem.id"
            >
              <schedule-report-item-card
                style="height: 100%;"
                flat
                shadowSize="0"
                :schedule-report-item="scheduleReportItem"
                :can-edit="false"
              />
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from "vue";
import axios from "@/backend/axios/index.js";
import ScheduleReportItemCard from "@/components/ScheduleReportItem/ScheduleReportItemCard.vue";
import {
  Table,
  TableColumn,
} from "element-ui";

const ElTable = Table
const ElTableColumn = TableColumn
const emit = defineEmits(["input", "search"]);

const expandedRows = ref([]);

const rowClicked = (row) => {
  if (expandedRows.value.includes(row.id)) {
    expandedRows.value = []
  } else {
    expandedRows.value = [row.id]
  }
}

const scheduleReportItems = ref([]);
const loadingScheduleReportItems = ref(false);
const getScheduleReportItems = async () => {
  const scheduleReportId = expandedRows.value[0]

  console.log("scheduleReportId", scheduleReportId)

  if (!scheduleReportId) {
    scheduleReportItems.value = []
    return
  }

  loadingScheduleReportItems.value = true;
  try {
    const response = await axios.get(`/api/v1/schedule_reports/${scheduleReportId}/schedule_report_items`, {
      params: {
        page: 1,
        per_page: 1000
      },
    });

    scheduleReportItems.value = response.data["schedule_report_items"] || [];
  } catch (error) {
    console.warn("[ScheduleReportForm][getScheduleReportItems]", error);
  }
  loadingScheduleReportItems.value = false;
};

watch(expandedRows, (value) => {
  if (value.length === 0) {
    scheduleReportItems.value = []
  }
  getScheduleReportItems()
})

defineProps({
  scheduleReports: {
    type: Array,
    required: true,
    default: () => ([]),
  },
  canEdit: {
    type: Boolean,
    required: false,
    default: false,
  },
})
</script>

<style lang="scss">
#schedule-report-book-list .el-table__expanded-cell {
  background-color: #8080800d;

  &:hover {
    background-color: #8080800d !important;
  }
}

// div.el-table .el-table__row:hover

</style>
